export const BOOKINGS_BASE_KEY = 'bookings';

export const bookingsApiQueryKeys = {
  all: () => [BOOKINGS_BASE_KEY] as const,
  byId: (bookingId: string) => [BOOKINGS_BASE_KEY, bookingId] as const,
  bill: (bookingId: string) => [BOOKINGS_BASE_KEY, bookingId, 'bill'] as const,
  transactions: (bookingId: string) =>
    [BOOKINGS_BASE_KEY, bookingId, 'transactions'] as const,
  snapshot: (bookingId: string) =>
    [BOOKINGS_BASE_KEY, bookingId, 'snapshot'] as const,
  acceptedConsents: (bookingId: string) =>
    [BOOKINGS_BASE_KEY, bookingId, 'accepted-consents'] as const,
  missingRequiredConsents: (bookingId: string) =>
    [
      BOOKINGS_BASE_KEY,
      bookingId,
      'accepted-consents',
      'missing-required',
    ] as const,
  participantSelections: (bookingId: string) =>
    [BOOKINGS_BASE_KEY, bookingId, 'participant-selections'] as const,
};
